module.exports = __webpack_public_path__ + "media/images/icons/truck-734f2a4fe3652faa84188f16d24e8373.png";